<template>
    <b-card no-body class="mb-0">

      <b-tabs card nav-class="mt-1" class="tabs" v-model="tab">
        <b-tab :title="dashboard.title" v-for="dashboard in dashboards" :key="dashboard.id">
          <template  v-slot:title>
            <div class="text-center px-3">
              <div class="h4 m-0 p-0">
                <count-to v-if="!!dashboard.report_ids && dashboard.report_ids.length > 0"
                  :start-val="0" :end-val="dashboard.report_ids.length" :duration="2000"/>
                <i v-else class="fa fa-spinner fa-spin"/>
              </div>
              <div>{{dashboard.title.toUpperCase()}}</div>
            </div>
          </template>
          <agents-reports :dashboard="dashboard"></agents-reports>
        </b-tab>
      </b-tabs>
    </b-card>
</template>

<script>
  import AgentsReports from '../components/CustomReportsManager/AgentsReports'

  export default {
    name: 'Dashboards',
    components: { AgentsReports },
    data() {
      const dashboards = this.$store.state.files.dashboards;
      const historical_dashboards = []
      for (const dashboard of dashboards) {
        if (dashboard["type"] === "historical") {
          historical_dashboards.push(dashboard)
        }
      }
      return {
        dashboards: historical_dashboards

      };
    }
  };
</script>
